import React from 'react'
import { Helmet } from 'react-helmet-async';
import GlobalSchema from './GlobalSchema';

const SEO = ({ seoData, globalSchema }) => {
  const seo = seoData || {};
  const hasPageSeo = seo && Object.keys(seo).length > 0;
  const title = seo.title || seo.og_title || seo.twitter_title || '';
  const description = seo.description || seo.og_description || seo.twitter_description || '';
  const canonicalUrl = seo.canonical_tag || seo.og_url || seo.url || '';
  const ogTitle = seo.og_title || title;
  const ogDescription = seo.og_description || description;
  const twitterTitle = seo.twitter_title || title;
  const twitterDescription = seo.twitter_description || description;

  return (
    <>
    {hasPageSeo && <Helmet>
      {/* Basic Meta Tags */}
      {title && <title>{title}</title>}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

       {/* Open Graph Meta Tags */}
      <meta property="og:locale" content={seo?.og_locale || 'en_US'} />
      <meta property="og:type" content={seo?.og_type || 'website'} />
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {(globalSchema?.og_site_name) && <meta property="og:site_name" content={globalSchema?.og_site_name} />}
      {seo.og_image && <meta property="og:image" content={seo.og_image} />}
     
     
      

      {/* Twitter Meta Tags */}
      {(globalSchema?.twitter_card ) &&<meta name="twitter:card" content={globalSchema?.twitter_card} />}
      {(globalSchema?.twitter_site ) && <meta name="twitter:site" content={globalSchema?.twitter_site} />}
      {twitterTitle && <meta name="twitter:title" content={twitterTitle} />}
      {twitterDescription && <meta name="twitter:description" content={twitterDescription} />}
      {seo.twitter_image && <meta name="twitter:image" content={seo.twitter_image} />}
      {(globalSchema?.twitter_creator) && <meta name="twitter:creator" content={globalSchema?.twitter_creator} />}

      {/* Faq Schema */}
      {seo.faq_schema && (
        <script type="application/ld+json">
          {(seo.faq_schema)}
        </script>
      )}
      {seo.article_schema && (
        <script type="application/ld+json">
          {(seo.article_schema)}
        </script>
      )}
      {(seo.additional_schemas || []).filter((item) => item?.schema).map((item, index) => (
        <script
          key={`${item.label || 'additional-schema'}-${index}`}
          type="application/ld+json"
          data-schema-label={item.label || undefined}
        >
          {item.schema}
        </script>
      ))}
    </Helmet>}
    <GlobalSchema schema={globalSchema} />
    </>
  );
};

export default SEO;
